import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { clientService } from "../../utils/services/clientService";
import { isMobile } from "../../globalStyles/mobile";
import AccountHeader from "../../components/account-setting-components/account-header";
import CropDialog from "../../components/account-setting-components/crop-dialog";
import ReturnAddressForm from "../../components/account-setting-components/return-address";
import BillingAddressForm from "../../components/account-setting-components/billing-address";
import PasswordSettings from "../../components/account-setting-components/password-setting";
import ClientDetails from "../../components/account-setting-components/client-details";
import LogoUploader from "../../components/account-setting-components/logo-uploader";
import ProfilePictureUploader from "../../components/account-setting-components/profile-picture-uploader";
import SidemenuPersonalisationModal from "../../components/account-setting-components/sidemenu-personalisation";
import KdlHealthModal from "../../components/account-setting-components/kdl-health";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";

const AccountSettings = () => {
  const user = localStorage.getItem("user");
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [base64ProfileImage, setBase64ProfileImage] = useState("");
  const [clientDetails, setClientDetails] = useState(null);
  const [formData, setFormData] = useState({
    logo: "",
    name: "",
    email: "",
    contact: "",
    business_name: "",
    primary_color: "",
    secondary_color: "",
    text_color: "",
  });
  const [returnAddress, setReturnAddress] = useState({
    name: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    country: "",
    zipcode: "",
  });
  const [billingAddress, setBillingAddress] = useState({
    name: "",
    address1: "",
    address2: "",
    city: "",
    province: "",
    country: "",
    zipcode: "",
  });

  const [editFlags, setEditFlags] = useState({
    isEditing: false,
    isEditingLogo: false,
    isEditingProfile: false,
    isEditingReturnAddress: false,
    isBillingAddress: false,
    editPassword: false,
  });
  const [menuModalOpen, setMenuModalOpen] = useState(false);
  const [kdlHealthOpen, setKdlHealthOpen] = useState(false);

  const [cropDialog, setCropDialog] = useState({
    open: false,
    crop: { unit: "px", aspect: 2 / 3 },
    imageSrc: null,
  });

  const fetchClientById = async () => {
    try {
      let client = await clientService.get(localStorage.getItem("client_id"));
      setClientDetails(client);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const isAdmin = JSON.parse(localStorage.getItem("user"))?.role === "admin";

    if (isAdmin) {
      // For admin users, populate formData with user data
      const userData = JSON.parse(localStorage.getItem("user"));
      const updatedFormData = {
        logo: "",
        name: userData.name,
        email: userData.email,
        contact: "",
        business_name: "",
        primary_color: "",
        secondary_color: "",
        text_color: "",
        _id: userData._id,
      };
      setFormData(updatedFormData);
    } else if (clientDetails) {
      // For client users, populate formData with client data
      const {
        logo,
        name,
        business_name,
        contact,
        email,
        primary_color,
        secondary_color,
        text_color,
        return_address,
        billing_address,
      } = clientDetails;

      const updatedFormData = {
        logo,
        name,
        business_name: business_name ?? name,
        contact: contact || "",
        email,
        primary_color,
        secondary_color,
        text_color,
      };

      setFormData(updatedFormData);

      if (return_address) {
        setReturnAddress(return_address);
      } else {
        setReturnAddress({});
      }

      if (billing_address) {
        setBillingAddress(billing_address);
      } else {
        setBillingAddress({});
      }
    }
  }, [clientDetails]);

  useEffect(() => {
    const isAdmin = JSON.parse(localStorage.getItem("user"))?.role === "admin";

    if (!isAdmin && localStorage.getItem("client_id")) {
      fetchClientById();
    } else if (isAdmin) {
      // For admin users, immediately populate formData with user data
      const userData = JSON.parse(localStorage.getItem("user"));
      const updatedFormData = {
        logo: "",
        name: userData.name,
        email: userData.email,
        contact: "",
        business_name: "",
        primary_color: "",
        secondary_color: "",
        text_color: "",
        _id: userData._id,
      };
      setFormData(updatedFormData);
    }
  }, []);

  const handleSave = async () => {
    console.log(formData);

    try {
      let payload = {
        ...formData,
        ...(base64Image && { logo: base64Image }),
        return_address: returnAddress,
        billing_address: billingAddress,
      };
      let response = await clientService.edit(
        payload,
        localStorage.getItem("client_id") || formData._id,
      );
      if (response) {
        fetchClientById();
        toast.success("Updated Successfully");
        localStorage.setItem("text_color", formData.text_color);
        localStorage.setItem("primary_color", formData.primary_color);
        localStorage.setItem("secondary_color", formData.secondary_color);
        if (base64Image || editFlags.isEditing) {
          window.location.reload();
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isAdmin = JSON.parse(localStorage.getItem("user"))?.role === "admin";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        overflowY: "auto",
        overflowX: "hidden",
        flexDirection: "column",
        maxHeight: isMobile() ? "85vh" : "calc(100vh - 85px)",
        paddingBottom: 5,
      }}
    >
      <AccountHeader isAdmin={isAdmin} navigate={navigate} />

      {isAdmin ? (
        // <ProfilePictureUploader
        //   formData={formData}
        //   imagePreview={profileImagePreview}
        //   setImagePreview={setProfileImagePreview}
        //   setBase64Image={setBase64ProfileImage}
        //   isEditingProfile={editFlags.isEditingProfile}
        //   setIsEditingProfile={(val) =>
        //     setEditFlags({ ...editFlags, isEditingProfile: val })
        //   }
        //   handleSave={handleSave}
        //   setCropDialog={setCropDialog}
        // />
        <></>
      ) : (
        <Box>
          <LogoUploader
            formData={formData}
            imagePreview={imagePreview}
            setImagePreview={setImagePreview}
            setBase64Image={setBase64Image}
            isEditingLogo={editFlags.isEditingLogo}
            setIsEditingLogo={(val) =>
              setEditFlags({ ...editFlags, isEditingLogo: val })
            }
            handleSave={handleSave}
            setCropDialog={setCropDialog}
          />
          {/* <ProfilePictureUploader
            formData={formData}
            imagePreview={profileImagePreview}
            setImagePreview={setProfileImagePreview}
            setBase64Image={setBase64ProfileImage}
            isEditingProfile={editFlags.isEditingProfile}
            setIsEditingProfile={(val) =>
              setEditFlags({ ...editFlags, isEditingProfile: val })
            }
            handleSave={handleSave}
            setCropDialog={setCropDialog}
          /> */}
        </Box>
      )}

      <ClientDetails
        user={JSON.parse(user)}
        formData={formData}
        setFormData={setFormData}
        isEditing={editFlags.isEditing}
        setIsEditing={(val) => setEditFlags({ ...editFlags, isEditing: val })}
        clientDetails={clientDetails}
        handleSave={handleSave}
        isAdmin={isAdmin} // Pass admin flag to ClientDetails
      />
      <Box
        onClick={() => setMenuModalOpen(true)}
        sx={{
          borderRadius: "8px",
          marginTop: "20px",
          padding: "20px",
          backgroundColor: "var(--bg-paper)",
          width: "99%",
          position: "relative",
          borderBottom: "0.5px solid var(--border-color)",
          display: "flex",
          alignItems: "center",
          gap: 2,
          cursor: "pointer",
          transition: "background-color 0.15s",
          "&:hover": { backgroundColor: "var(--hover-bg)" },
        }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "10px",
            backgroundColor: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ViewSidebarOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            sx={{
              fontFamily: "poppins",
              fontWeight: 600,
              fontSize: "14px",
              color: "var(--text-primary)",
            }}
          >
            Menu Personalisation
          </Typography>
          <Typography
            sx={{
              fontFamily: "poppins",
              fontSize: "12px",
              color: "var(--text-secondary)",
              mt: 0.25,
            }}
          >
            Customise the order of your sidebar navigation items
          </Typography>
        </Box>
        <ArrowForwardIosIcon
          sx={{ fontSize: 14, color: "var(--text-secondary)" }}
        />
      </Box>
      <SidemenuPersonalisationModal
        open={menuModalOpen}
        onClose={() => setMenuModalOpen(false)}
      />

      {isAdmin && (
        <>
          <Box
            onClick={() => setKdlHealthOpen(true)}
            sx={{
              borderRadius: "8px",
              marginTop: "20px",
              padding: "20px",
              backgroundColor: "var(--bg-paper)",
              width: "99%",
              position: "relative",
              borderBottom: "0.5px solid var(--border-color)",
              display: "flex",
              alignItems: "center",
              gap: 2,
              cursor: "pointer",
              transition: "background-color 0.15s",
              "&:hover": { backgroundColor: "var(--hover-bg)" },
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                backgroundColor: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <MonitorHeartOutlinedIcon sx={{ color: "#fff", fontSize: 20 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: "poppins",
                  fontWeight: 600,
                  fontSize: "14px",
                  color: "var(--text-primary)",
                }}
              >
                Data Health
              </Typography>
              <Typography
                sx={{
                  fontFamily: "poppins",
                  fontSize: "12px",
                  color: "var(--text-secondary)",
                  mt: 0.25,
                }}
              >
                Check that the data behind your reports and forecasts is complete and up to date
              </Typography>
            </Box>
            <ArrowForwardIosIcon
              sx={{ fontSize: 14, color: "var(--text-secondary)" }}
            />
          </Box>
          <KdlHealthModal
            open={kdlHealthOpen}
            onClose={() => setKdlHealthOpen(false)}
          />
        </>
      )}

      {!isAdmin && (
        <>
          {/* Menu personalisation trigger card */}

          <PasswordSettings
            editPassword={editFlags.editPassword}
            setEditPassword={(val) =>
              setEditFlags({ ...editFlags, editPassword: val })
            }
            user={user}
          />
          <BillingAddressForm
            billingAddress={billingAddress}
            setBillingAddress={setBillingAddress}
            isBillingAddress={editFlags.isBillingAddress}
            setIsBillingAddress={(val) =>
              setEditFlags({ ...editFlags, isBillingAddress: val })
            }
            handleSave={handleSave}
          />
          <ReturnAddressForm
            returnAddress={returnAddress}
            setReturnAddress={setReturnAddress}
            isEditingReturnAddress={editFlags.isEditingReturnAddress}
            setIsEditingReturnAddress={(val) =>
              setEditFlags({ ...editFlags, isEditingReturnAddress: val })
            }
            handleSave={handleSave}
          />
        </>
      )}

      <CropDialog
        cropDialog={cropDialog}
        setCropDialog={setCropDialog}
        setBase64Image={isAdmin ? setBase64ProfileImage : setBase64Image}
        setImagePreview={isAdmin ? setProfileImagePreview : setImagePreview}
      />
    </Box>
  );
};

export default AccountSettings;
